// @flow
import cuckoo from "common/services/cuckoo/cuckoo"
import type { TrackingEvent } from "mmb/services/tracking/constants/trackingEventTypes"
import type { EventProps } from "common/services/cuckoo/cuckoo"

export default ({ module, action, detail }: TrackingEvent, values?: EventProps) => {
  cuckoo.track({ category: "Manage", subCategory: module, ...action, detail: detail || "" }, values)
}
